import { computed } from 'vue';
import { get } from 'lodash';
import { useFlag } from '@loadsmart/vue-feature-flags';

import useYardTaskEvent from './useYardTaskEvent';

import type { YardTaskTimelineEvent } from './types';
import type { UseYardTaskEventOptions } from './useYardTaskEvent';

const CANCEL_REASON_FLAG = 'enable-yard-task-cancel-reason';

export default function useYardTaskCancelledEvent(
  event: YardTaskTimelineEvent,
  options: UseYardTaskEventOptions
) {
  const baseEventData = useYardTaskEvent(event, options);

  const cancelReasonFlag = useFlag(CANCEL_REASON_FLAG);

  // `reason` is a top-level column on the YardTaskEvent row, so it lives at `data.reason`
  // (unlike the nested payload under `data.data` that other events read from).
  const reason = computed<string | null>(() => {
    const value = event?.data?.reason;
    return typeof value === 'string' && value.trim().length > 0 ? value : null;
  });

  const shouldShowReason = computed(
    () => Boolean(cancelReasonFlag.value.enabled) && reason.value !== null
  );

  return {
    ...baseEventData,
    reason,
    shouldShowReason
  };
}
